<template>
  <div class="toggle">
    <input
      v-model="syncToggle"
      data-testid="toggle-checkbox"
      type="checkbox"
      class="check"
      @click="emitClicked"
    />
    <span class="switch" />
    <span class="track" />
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: ['toggle'],
  computed: {
    syncToggle: {
      get() {
        return this.toggle
      },
      set(value) {
        this.$emit('update:toggle', value)
      },
    },
  },
  methods: {
    emitClicked() {
      this.$emit('toggle-clicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle {
  position: relative;
  width: 50px;
  height: 30px;
  border-radius: 100px;
  background-color: $light-grey;
  overflow: hidden;
  box-shadow: inset 0 0 2px 1px rgba(216, 205, 205, 0.05);
}
.check {
  position: absolute;
  display: block;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 6;
  &:checked ~ .track {
    box-shadow: inset 0 0 0 20px $green;
  }
  &:checked ~ .switch {
    left: 22px;
    right: 2px;
    top: 2px;
    bottom: 2px;
    transition: 0.35s cubic-bezier(0.86, 0.15, 0.135, 0.785);
    transition-property: left, right;
    transition-delay: 0.05s, 0s;
  }
}
.switch {
  display: block;
  position: absolute;
  right: 22px;
  left: 2px;
  top: 2px;
  bottom: 2px;
  background-color: $white;
  border-radius: 36px;
  z-index: 1;
  transition: 0.35s cubic-bezier(0.86, 0.15, 0.135, 0.785);
  transition-property: left, right;
  transition-delay: 0s, 0.05s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.track {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: 0.35s cubic-bezier(0.86, 0.15, 0.135, 0.785);
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.05);
  border-radius: 40px;
}
</style>
